export default "__VITE_ASSET__D_NAWR8J__"